import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { AddShortcutRequest } from "./request/add-shortcut";
import { AttributeRequest } from "./request/attribute";
import { AddToCollectionRequest, DeleteFromCollectionRequest } from "./request/collection";
import { CreateDocRequest } from "./request/create-doc";
import { CreateFolderRequest } from "./request/create-folder";
import { CreateLocalFileRequest } from "./request/create-local-file";
import { DeleteFileRequest, DeleteFolderRequest } from "./request/delete";
import { DeleteLocalFileRequest } from "./request/delete-local-file";
import { DocInfoRequest } from "./request/doc-info";
import { DocListRequest } from "./request/doc-list";
import { FileCloneRequest } from "./request/file-clone";
import { FolderListRequest } from "./request/folder-list";
import { GetLocalFileRequest } from "./request/get-local-file";
import { MoveFileRequest, MoveFolderRequest } from "./request/move";
import { OpenInLocalFolderRequest } from "./request/open-in-local-folder";
import { OpenLocalFileRequest } from "./request/open-local-file";
import { PermissionsRequest } from "./request/permissions";
import { PinRequest, UnpinRequest } from "./request/pin";
import { QuickAccessAddRequest, QuickAccessDeleteRequest, QuickAccessListRequest } from "./request/quick-access";
import { RecoverFileRequest, RecoverFolderRequest } from "./request/recover/recover";
import { RevealRequest } from "./request/reveal";
import { SearchListRequest } from "./request/search-list";
import { SetFilePolicyRequest } from "./request/set-policy";
import { SpaceListRequest } from "./request/space-list";
import { StorageListRequest } from "./request/storage-list";
import { StorageSpaceRequest } from "./request/storage-space";
import { TrashDeleteFileRequest, TrashDeleteFolderRequest } from "./request/trash-delete";
import { TrashListRequest } from "./request/trash-list";
import { DriveVersionsDeleteRequest } from "./request/versions-delete";
import { DriveVersionsListRequest } from "./request/versions-list";
import { ClearTrashRequest } from "./request/clear-trash";
import { DeleteSpaceFolderRequest } from "./request/delete-space-folder";
import { GetFolderAnnouncementRequest, SetFolderAnnouncementRequest } from "./request/folder-announcement";
import { GetCooperationMemberRequest } from "./request/get-cooperation-member";
import { QuitSpaceFolderRequest } from "./request/quit-space-folder";
import { RenameFileRequest } from "./request/rename-file";
import { RenameFolderRequest } from "./request/rename-folder";
import { StopCollaborationRequest } from "./request/stop-collaboration";
import { UpgradeCollaborationRequest } from "./request/upgrade-collaboration";
export { getDownloadUrl } from "./request/download-url";
export { fetchDriveFile, fetchFileInfo } from "./request/file-info";
export { fetchPreviewInfo } from "./request/query";
export * from "./request/file-info";
export * from "./request/drive-file";

/**
 * 获取腾讯文档 drive 某个列表的某段数据
 *
 * 特殊文件夹 见 {@link SpecialFolderId}
 */
export function getDocList(_x) {
  return _getDocList.apply(this, arguments);
}

/**
 * 在腾讯文档 drive 中搜索符合条件的文件
 *
 * 特殊文件夹 见 {@link SpecialFolderId}
 */
function _getDocList() {
  _getDocList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new DocListRequest(params).send());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getDocList.apply(this, arguments);
}
export function searchFile(_x2) {
  return _searchFile.apply(this, arguments);
}

/**
 * 获取腾讯文档 drive 我的文档下的所有文件夹
 */
function _searchFile() {
  _searchFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new SearchListRequest(params).send());
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _searchFile.apply(this, arguments);
}
export function getFolderList(_x3) {
  return _getFolderList.apply(this, arguments);
}

/**
 * 查询一批文件或文件夹是否符合给定的权限
 */
function _getFolderList() {
  _getFolderList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", new FolderListRequest(params).send());
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getFolderList.apply(this, arguments);
}
export function getPermissionList(_x4) {
  return _getPermissionList.apply(this, arguments);
}

/**
 * 新建在线文档
 */
function _getPermissionList() {
  _getPermissionList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", new PermissionsRequest(params).send());
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getPermissionList.apply(this, arguments);
}
export function createDoc(_x5) {
  return _createDoc.apply(this, arguments);
}

/**
 * 在本机文件系统中创建本地文件（需在腾讯文档桌面端 2.3.25+ 版本中才能运行）
 */
function _createDoc() {
  _createDoc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", new CreateDocRequest(params).send());
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _createDoc.apply(this, arguments);
}
export function createLocalFile(_x6) {
  return _createLocalFile.apply(this, arguments);
}

/**
 * 在本机文件系统中删除本地文件（需在腾讯文档桌面端 2.3.25+ 版本中才能运行）
 */
function _createLocalFile() {
  _createLocalFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", new CreateLocalFileRequest(params).send());
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _createLocalFile.apply(this, arguments);
}
export function deleteLocalFile(_x7) {
  return _deleteLocalFile.apply(this, arguments);
}

/**
 * 在本机文件系统中打开本地文件（需在腾讯文档桌面端 2.3.25+ 版本中才能运行）
 */
function _deleteLocalFile() {
  _deleteLocalFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", new DeleteLocalFileRequest(params).send());
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _deleteLocalFile.apply(this, arguments);
}
export function openLocalFile(_x8) {
  return _openLocalFile.apply(this, arguments);
}

/**
 * 在本机文件系统中获取本地文件（需在腾讯文档桌面端 2.3.25+ 版本中才能运行）
 */
function _openLocalFile() {
  _openLocalFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", new OpenLocalFileRequest(params).send());
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _openLocalFile.apply(this, arguments);
}
export function getLocalFile(_x9) {
  return _getLocalFile.apply(this, arguments);
}

/**
 * 在本机文件系统中打开本地文件所在目录（需在腾讯文档桌面端 2.3.25+ 版本中才能运行）
 */
function _getLocalFile() {
  _getLocalFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", new GetLocalFileRequest(params).send());
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _getLocalFile.apply(this, arguments);
}
export function openInLocalFolder(_x10) {
  return _openInLocalFolder.apply(this, arguments);
}

/**
 * 修改文件名称
 */
function _openInLocalFolder() {
  _openInLocalFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(params) {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", new OpenInLocalFolderRequest(params).send());
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _openInLocalFolder.apply(this, arguments);
}
export function renameFile(_x11) {
  return _renameFile.apply(this, arguments);
}

/**
 * 修改文件夹名称
 */
function _renameFile() {
  _renameFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(params) {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", new RenameFileRequest(params).send());
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _renameFile.apply(this, arguments);
}
export function renameFolder(_x12) {
  return _renameFolder.apply(this, arguments);
}

/**
 * 删除文件
 */
function _renameFolder() {
  _renameFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params) {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", new RenameFolderRequest(params).send());
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _renameFolder.apply(this, arguments);
}
export function deleteFile(_x13) {
  return _deleteFile.apply(this, arguments);
}

/**
 * 删除文件夹
 */
function _deleteFile() {
  _deleteFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", new DeleteFileRequest(params).send());
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _deleteFile.apply(this, arguments);
}
export function deleteFolder(_x14) {
  return _deleteFolder.apply(this, arguments);
}

/**
 * 获取快速访问内容.
 */
function _deleteFolder() {
  _deleteFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(params) {
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", new DeleteFolderRequest(params).send());
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _deleteFolder.apply(this, arguments);
}
export function getQuickAccess() {
  return _getQuickAccess.apply(this, arguments);
}

/**
 * 添加文件/文件夹/快捷方式到快速访问.
 *
 * 对于已经添加的项, 也可以使用此 API 来修改其顺序.
 */
function _getQuickAccess() {
  _getQuickAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", new QuickAccessListRequest().send());
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _getQuickAccess.apply(this, arguments);
}
export function addToQuickAccess(_x15) {
  return _addToQuickAccess.apply(this, arguments);
}

/**
 * 从快速访问中删除文件/文件夹/快捷方式.
 */
function _addToQuickAccess() {
  _addToQuickAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(params) {
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          return _context16.abrupt("return", new QuickAccessAddRequest(params).send());
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _addToQuickAccess.apply(this, arguments);
}
export function deleteFromQuickAccess(_x16) {
  return _deleteFromQuickAccess.apply(this, arguments);
}

/**
 * 收藏.
 */
function _deleteFromQuickAccess() {
  _deleteFromQuickAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(params) {
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", new QuickAccessDeleteRequest(params).send());
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _deleteFromQuickAccess.apply(this, arguments);
}
export function addToCollection(_x17) {
  return _addToCollection.apply(this, arguments);
}

/**
 * 取消收藏.
 */
function _addToCollection() {
  _addToCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(params) {
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          return _context18.abrupt("return", new AddToCollectionRequest(params).send());
        case 1:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _addToCollection.apply(this, arguments);
}
export function deleteFromCollection(_x18) {
  return _deleteFromCollection.apply(this, arguments);
}

/**
 * 获取当前储存空间使用情况.
 */
function _deleteFromCollection() {
  _deleteFromCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(params) {
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          return _context19.abrupt("return", new DeleteFromCollectionRequest(params).send());
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _deleteFromCollection.apply(this, arguments);
}
export function getStorageSpace() {
  return _getStorageSpace.apply(this, arguments);
}

/**
 * 获取共享空间列表.
 */
function _getStorageSpace() {
  _getStorageSpace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          return _context20.abrupt("return", new StorageSpaceRequest().send());
        case 1:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _getStorageSpace.apply(this, arguments);
}
export function getSpaceList(_x19) {
  return _getSpaceList.apply(this, arguments);
}

/**
 * 解散共享空间.
 */
function _getSpaceList() {
  _getSpaceList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(params) {
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.abrupt("return", new SpaceListRequest(params).send());
        case 1:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _getSpaceList.apply(this, arguments);
}
export function deleteSpaceFolder(_x20) {
  return _deleteSpaceFolder.apply(this, arguments);
}

/**
 * 退出共享空间.
 */
function _deleteSpaceFolder() {
  _deleteSpaceFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(params) {
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.abrupt("return", new DeleteSpaceFolderRequest(params).send());
        case 1:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _deleteSpaceFolder.apply(this, arguments);
}
export function quitSpaceFolder(_x21) {
  return _quitSpaceFolder.apply(this, arguments);
}

/**
 * 获取回收站列表.
 */
function _quitSpaceFolder() {
  _quitSpaceFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(params) {
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          return _context23.abrupt("return", new QuitSpaceFolderRequest(params).send());
        case 1:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _quitSpaceFolder.apply(this, arguments);
}
export function getTrashList(_x22) {
  return _getTrashList.apply(this, arguments);
}

/**
 * 拉取版本管理列表
 */
function _getTrashList() {
  _getTrashList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(params) {
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.abrupt("return", new TrashListRequest(params).send());
        case 1:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _getTrashList.apply(this, arguments);
}
export function getDriveVersionsList(_x23) {
  return _getDriveVersionsList.apply(this, arguments);
}

/**
 * 删除版本
 */
function _getDriveVersionsList() {
  _getDriveVersionsList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(params) {
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.abrupt("return", new DriveVersionsListRequest(params).send());
        case 1:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _getDriveVersionsList.apply(this, arguments);
}
export function deleteDriveVersion(_x24) {
  return _deleteDriveVersion.apply(this, arguments);
}

/**
 * 查看文档所在位置.
 */
function _deleteDriveVersion() {
  _deleteDriveVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(params) {
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", new DriveVersionsDeleteRequest(params).send());
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _deleteDriveVersion.apply(this, arguments);
}
export function reveal(_x25) {
  return _reveal.apply(this, arguments);
}

/**
 * 新建文件夹.
 */
function _reveal() {
  _reveal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(params) {
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          return _context27.abrupt("return", new RevealRequest(params).send());
        case 1:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _reveal.apply(this, arguments);
}
export function createFolder(_x26) {
  return _createFolder.apply(this, arguments);
}

/**
 * 彻底删除文件
 */
function _createFolder() {
  _createFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(params) {
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          return _context28.abrupt("return", new CreateFolderRequest(params).send());
        case 1:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _createFolder.apply(this, arguments);
}
export function trashDeleteFile(_x27) {
  return _trashDeleteFile.apply(this, arguments);
}

/**
 * 彻底删除文件夹
 */
function _trashDeleteFile() {
  _trashDeleteFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(params) {
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          return _context29.abrupt("return", new TrashDeleteFileRequest(params).send());
        case 1:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _trashDeleteFile.apply(this, arguments);
}
export function trashDeleteFolder(_x28) {
  return _trashDeleteFolder.apply(this, arguments);
}

/**
 * 移动文件
 */
function _trashDeleteFolder() {
  _trashDeleteFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(params) {
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          return _context30.abrupt("return", new TrashDeleteFolderRequest(params).send());
        case 1:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _trashDeleteFolder.apply(this, arguments);
}
export function moveFile(_x29) {
  return _moveFile.apply(this, arguments);
}

/**
 * 移动文件夹
 */
function _moveFile() {
  _moveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(params) {
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          return _context31.abrupt("return", new MoveFileRequest(params).send());
        case 1:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _moveFile.apply(this, arguments);
}
export function moveFolder(_x30) {
  return _moveFolder.apply(this, arguments);
}

/**
 * 获取文档权限
 */
function _moveFolder() {
  _moveFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(params) {
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          return _context32.abrupt("return", new MoveFolderRequest(params).send());
        case 1:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _moveFolder.apply(this, arguments);
}
export function fetchAttribute(_x31) {
  return _fetchAttribute.apply(this, arguments);
}

/**
 * 还原文件
 */
function _fetchAttribute() {
  _fetchAttribute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(params) {
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          return _context33.abrupt("return", new AttributeRequest(params).send());
        case 1:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _fetchAttribute.apply(this, arguments);
}
export function recoverFile(_x32) {
  return _recoverFile.apply(this, arguments);
}

/**
 * 还原文件夹
 */
function _recoverFile() {
  _recoverFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(params) {
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          return _context34.abrupt("return", new RecoverFileRequest(params).send());
        case 1:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _recoverFile.apply(this, arguments);
}
export function recoverFolder(_x33) {
  return _recoverFolder.apply(this, arguments);
}

/**
 * Drive 文件生成副本.
 */
function _recoverFolder() {
  _recoverFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(params) {
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          return _context35.abrupt("return", new RecoverFolderRequest(params).send());
        case 1:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _recoverFolder.apply(this, arguments);
}
export function fileClone(_x34) {
  return _fileClone.apply(this, arguments);
}
function _fileClone() {
  _fileClone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(params) {
    return _regeneratorRuntime().wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          return _context36.abrupt("return", new FileCloneRequest(params).send());
        case 1:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _fileClone.apply(this, arguments);
}
export function getDocInfo(_x35) {
  return _getDocInfo.apply(this, arguments);
}

/**
 * 获取容量页列表
 */
function _getDocInfo() {
  _getDocInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(params) {
    return _regeneratorRuntime().wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.abrupt("return", new DocInfoRequest(params).send());
        case 1:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _getDocInfo.apply(this, arguments);
}
export function getStorageList(_x36) {
  return _getStorageList.apply(this, arguments);
}

/**
 * 获取文件夹公告.
 */
function _getStorageList() {
  _getStorageList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(params) {
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          return _context38.abrupt("return", new StorageListRequest(params).send());
        case 1:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _getStorageList.apply(this, arguments);
}
export function getFolderAnnouncement(_x37) {
  return _getFolderAnnouncement.apply(this, arguments);
}

/**
 * 设置文件夹公告.
 */
function _getFolderAnnouncement() {
  _getFolderAnnouncement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(params) {
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          return _context39.abrupt("return", new GetFolderAnnouncementRequest(params).send());
        case 1:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _getFolderAnnouncement.apply(this, arguments);
}
export function setFolderAnnouncement(_x38) {
  return _setFolderAnnouncement.apply(this, arguments);
}

/**
 * 获取协作者列表.
 */
function _setFolderAnnouncement() {
  _setFolderAnnouncement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(params) {
    return _regeneratorRuntime().wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          return _context40.abrupt("return", new SetFolderAnnouncementRequest(params).send());
        case 1:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return _setFolderAnnouncement.apply(this, arguments);
}
export function getCooperationMember(_x39) {
  return _getCooperationMember.apply(this, arguments);
}

/**
 * 停止协作.
 */
function _getCooperationMember() {
  _getCooperationMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(params) {
    return _regeneratorRuntime().wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          return _context41.abrupt("return", new GetCooperationMemberRequest(params).send());
        case 1:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return _getCooperationMember.apply(this, arguments);
}
export function stopCollaboration(_x40) {
  return _stopCollaboration.apply(this, arguments);
}

/**
 * 升级协作空间.
 */
function _stopCollaboration() {
  _stopCollaboration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(params) {
    return _regeneratorRuntime().wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          return _context42.abrupt("return", new StopCollaborationRequest(params).send());
        case 1:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return _stopCollaboration.apply(this, arguments);
}
export function upgradeCollaboration(_x41) {
  return _upgradeCollaboration.apply(this, arguments);
}

/**
 * 清空回收站.
 */
function _upgradeCollaboration() {
  _upgradeCollaboration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(params) {
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          return _context43.abrupt("return", new UpgradeCollaborationRequest(params).send());
        case 1:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return _upgradeCollaboration.apply(this, arguments);
}
export function clearTrash() {
  return _clearTrash.apply(this, arguments);
}

/**
 * 添加文件或文件夹快捷方式
 */
function _clearTrash() {
  _clearTrash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          return _context44.abrupt("return", new ClearTrashRequest(null).send());
        case 1:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return _clearTrash.apply(this, arguments);
}
export function addShortcut(_x42) {
  return _addShortcut.apply(this, arguments);
}

/**
 * 设置文档权限
 */
function _addShortcut() {
  _addShortcut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(params) {
    return _regeneratorRuntime().wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          return _context45.abrupt("return", new AddShortcutRequest(params).send());
        case 1:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return _addShortcut.apply(this, arguments);
}
export function setFilePolicy(_x43) {
  return _setFilePolicy.apply(this, arguments);
}

/**
 * 置顶.
 */
function _setFilePolicy() {
  _setFilePolicy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(params) {
    return _regeneratorRuntime().wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          return _context46.abrupt("return", new SetFilePolicyRequest(params).send());
        case 1:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return _setFilePolicy.apply(this, arguments);
}
export function pin(_x44) {
  return _pin.apply(this, arguments);
}

/**
 * 取消置顶.
 */
function _pin() {
  _pin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(params) {
    return _regeneratorRuntime().wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          return _context47.abrupt("return", new PinRequest(params).send());
        case 1:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return _pin.apply(this, arguments);
}
export function unpin(_x45) {
  return _unpin.apply(this, arguments);
}
function _unpin() {
  _unpin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(params) {
    return _regeneratorRuntime().wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          return _context48.abrupt("return", new UnpinRequest(params).send());
        case 1:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return _unpin.apply(this, arguments);
}
//# sourceMappingURL=drive-api.js.map